module.exports = __webpack_public_path__ + "img/banner.f37a41c4.jpg";